import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Vintage terminal motif preserved as one optional tab.
export function RawTerminal({ markdown, mode, projectName }) {
  return (
    <section
      className="relative rounded-2xl bg-black border border-[#1EDB6F] shadow-[0_18px_50px_rgba(0,0,0,0.35)] overflow-hidden terminal-scanlines"
      data-testid="synberry-output-raw"
    >
      <div className="relative z-10">
        <div className="flex items-center justify-between px-4 py-2 border-b border-[#1EDB6F]/60">
          <div className="flex items-center gap-1.5">
            <span className="inline-block h-2.5 w-2.5 rounded-full border border-[#1EDB6F]" />
            <span className="inline-block h-2.5 w-2.5 rounded-full border border-[#1EDB6F]" />
            <span className="inline-block h-2.5 w-2.5 rounded-full border border-[#1EDB6F]" />
          </div>
          <div className="font-mono-term text-[11px] text-[#39FF88] opacity-80">
            gooseberry://{(projectName || "untitled").toLowerCase().replace(/\s+/g, "-")}, mode:{mode}
          </div>
        </div>
        <div className="p-5 sm:p-6 font-mono-term text-[13px] leading-relaxed text-[#39FF88] max-h-[70vh] overflow-y-auto term-markdown">
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" />,
            }}
          >
            {markdown}
          </ReactMarkdown>
          <div className="mt-4">$ <span className="term-cursor" /></div>
        </div>
      </div>
    </section>
  );
}
